import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bookingActions from 'actions/bookings/actions'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row-dropdown'
import TCol from 'components/shared/table/table-column'
import ModalHandler from 'components/shared/modal/modal-handler'
import Modal from 'components/shared/modal'
import QuestionaireModalForm from 'forms/shared/questionaire-form'
import Instruction from 'components/shared/instructions/booking'
import TablePagination from 'components/shared/table/table-pagination'
import SortIcon from 'components/shared/icons/sort'
import SortedUp from 'components/shared/icons/sortedUp'
import SortedDown from 'components/shared/icons/sortedDown'
import ColStatus from '../col-status'
import { leadsInstruction, leadCancelReasons, declineInquiryReasons } from '../dataset'

const LeadsList = ({ selectedVenue, headers, list, sort, page, limit, total, pageLeads, sortLeads, fetchLeads, acceptLead, archiveLead, cancelSpace, declineLead, handleSwitchContent }) => {
  useEffect(() => { fetchLeads({ selectedVenue }) }, [selectedVenue, limit, page, sort])

  const renderCanceModal = (id, toggle) => (
    <Modal
      className="bg-secondary-lightgray w-full rounded shadow-lg z-50"
      title="Why did you cancel the request?"
      titleClassName="mt-10 text-center text-xl">
      <QuestionaireModalForm
        onAccept={values => {
          cancelSpace({ id, ...values });
          toggle()
        }}
        onClose={toggle} reasons={leadCancelReasons} />
    </Modal>
  )

  const renderDeclineModal = (id, toggle) => (
    <Modal
      className="bg-secondary-lightgray w-full rounded shadow-lg z-50"
      title="Why did you cancel the request?"
      titleClassName="mt-10 text-center text-xl">
      <QuestionaireModalForm
        onAccept={values => {
          declineLead({ id, ...values });
          toggle()
        }}
        onClose={toggle} reasons={declineInquiryReasons} />
    </Modal>
  )

  const handlePending = (leadType, id) => {
    return leadType === 'INQUIRY' ? (
      <>
        <li className="cursor-pointer font-semibold" onClick={() => acceptLead({ id, status: 'accepted' })}>Accept</li>
        <li className="text-primary-black px-1 font-thin text-base">|</li>
        <ModalHandler title="Decline" className="cursor-pointer font-semibold">
          {({ toggle }) => renderDeclineModal(id, toggle)}
        </ModalHandler>
      </>
    ) : <li className="mx-1 cursor-pointer font-semibold" onClick={() => acceptLead({ id, status: 'accepted' })}>Accept</li>
  }

  const switchAction = data => {
    /* eslint-disable camelcase */
    const { id, clientId, leadType, status, conversation_id, space_id } = data
    switch (status) {
      case 'accepted':
        return (
          <>
            <li className="font-semibold">
              <Link to={`/merchant/messages/${conversation_id}/conversation`} target="_blank">Message Client</Link>
              <span className="text-black mx-1 text-base font-thin">|</span>
            </li>
            <li onClick={() => handleSwitchContent({ value: 'send-proposal', data: { id, clientId, spaceId: space_id } })} className="cursor-pointer font-semibold">
              Send Proposal
              <span className="text-black mx-1 text-base font-thin">|</span>
            </li>
            <ModalHandler title="Cancel" className="cursor-pointer font-semibold">
              {({ toggle }) => renderCanceModal(id, toggle)}
            </ModalHandler>
          </>
        )
      case 'pending':
        return handlePending(leadType, id)
      default:
        return <li className="cursor-pointer font-semibold" onClick={() => archiveLead({ id })}>
            Archive
          </li>
    }
  }
  const DisplayDetails = (item, status) => {
    const { requestDate, notes, client, email, phone } = item
    const isNotPending = status !== 'pending'

    return (
      <ul className="p-3 text-sm">
        <li className="leading-loose">
          <div className="w-full inline-flex">
            <div className="w-1/12 font-semibold">Request Date: </div>
            <span>{requestDate}</span>
          </div>
        </li>
        <li className="leading-loose">
          <div className="w-full inline-flex">
            <div className="w-1/12 font-semibold">Notes: </div>
            <span>{notes}</span>
          </div>
        </li>
        {isNotPending && <>
            <li className="leading-loose">
              <div className="w-full inline-flex">
                <div className="w-1/12 font-semibold">Client Name: </div>
                <span>{client}</span>
              </div>
            </li>
            <li className="leading-loose">
              <div className="w-full inline-flex">
                <div className="w-1/12 font-semibold">Email: </div>
                <span>{email}</span>
              </div>
            </li>
            <li className="leading-loose">
              <div className="w-full inline-flex">
                <div className="w-1/12 font-semibold">Phone: </div>
                <span>{phone}</span>
              </div>
            </li>
        </>}
      </ul>
    )
  }

  return (
    <div className="merchant-leads-list">
      <div className="mt-5">
        <Instruction instructions={leadsInstruction} />
        <div className="overflow-auto">
          <Table classes="w-full border-collapse">
            <THead classes="text-xs text-ct bg-lightgray font-semibold leading-px-45">
                {headers.map((header, key) => {
                  let sortIcon = <SortIcon />
                  let nextOrder = 'desc'

                  if (sort.field === header.field) {
                    if (sort.order === 'desc') {
                      sortIcon = <SortedDown />
                      nextOrder = 'asc'
                    } else {
                      sortIcon = <SortedUp />
                    }
                  }

                  return (
                  <TCol
                    classes="p-3 text-primary-black"
                    key={key}
                    align={header.align || 'left'}
                    onClick={() => header.sortable && sortLeads({ field: header.field, order: nextOrder })}
                  >
                    <div
                      className={`flex items-center gap-1 ${header.sortable ? 'cursor-pointer' : ''}`}
                    >
                      {header.name} {header.sortable && sortIcon}
                    </div>
                  </TCol>
                )
              })}
            </THead>
            <TBody>
              {list.map(item => (
                <TRow classes="border-t text-ct text-sm hover:bg-gray-100 leading-px-45"
                  key={item.id} PassedComponent={() => DisplayDetails(item.details, item.status)}>
                  <TCol classes={`p-3 text-primary-black ${item.status === 'pending' ? 'font-semibold' : ''}`}>{item.createDate}</TCol>
                  <TCol classes={`p-3 text-primary-black ${item.status === 'pending' ? 'font-semibold' : ''}`}>{item.leadType}</TCol>
                  <TCol classes={`p-3 text-primary-black ${item.status === 'pending' ? 'font-semibold' : ''}`}>{item.requestDate}</TCol>
                  <TCol classes={`p-3 text-primary-black ${item.status === 'pending' ? 'font-semibold' : ''}`}>{item.client}</TCol>
                  <TCol classes="p-3 text-primary-orange">
                    <Link to={item.spaceLink} target="_blank">{item.space}</Link>
                  </TCol>
                  <ColStatus classes="p-3 font-semibold text-xs" status={item.status} />
                  <TCol classes="p-3" align="left">
                    <ul className="flex text-center text-primary-orange whitespace-no-wrap">
                      {switchAction(item)}
                    </ul>
                  </TCol>
                </TRow>
              ))}
            </TBody>
          </Table>
        </div>
        <TablePagination
          currentPage={page}
          onPageChange={(newPage) => pageLeads({ page: newPage })}
          onPageSizeChange={(newPageSize) => pageLeads({ limit: newPageSize })}
          pageSize={limit}
          totalCount={total}
          className="mt-5"
        />
      </div>
    </div>
  )
}

LeadsList.propTypes = {
  selectedVenue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  headers: PropTypes.array.isRequired,
  fetchLeads: PropTypes.func.isRequired,
  pageLeads: PropTypes.func.isRequired,
  acceptLead: PropTypes.func.isRequired,
  cancelSpace: PropTypes.func.isRequired,
  declineLead: PropTypes.func.isRequired,
  // sendProposal: PropTypes.func.isRequired,
  archiveLead: PropTypes.func.isRequired,
  handleSwitchContent: PropTypes.func.isRequired,
  list: PropTypes.array,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  sort: PropTypes.object.isRequired,
  sortLeads: PropTypes.func.isRequired,
}

const mapStateToProps = ({ bookings }) => ({
  headers: bookings.merchant.leads.headers,
  list: bookings.merchant.leads.list,
  page: bookings.merchant.leads.page,
  limit: bookings.merchant.leads.limit,
  total: bookings.merchant.leads.total,
  sort: bookings.merchant.leads.sort,
})

const mapDispatchToProps = {
  fetchLeads: bookingActions.fetchMerchantLeads,
  pageLeads: bookingActions.pageMerchantLeads,
  sortLeads: bookingActions.sortMerchantLeads,
  acceptLead: bookingActions.acceptMerchantLead,
  cancelSpace: bookingActions.merchantCancelSpace,
  declineLead: bookingActions.declineMerchantLead,
  sendProposal: bookingActions.merchantSendProposal,
  archiveLead: bookingActions.archiveMerchantLead,
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadsList)
